import { useBlocker } from 'react-router-dom';

import { useFormContext } from 'react-hook-form';
import { EntityDiscardChangedDialog } from 'app/agriculture/entities/entity_discard_changes_dialog';

export function FormDiscardChangesBlocker() {
    const formContext = useFormContext();
    if (!formContext) {
        throw Error('FormDiscardChangesBlocker needs a FormProvider');
    }
    const {
        formState: { isDirty, isSubmitted, isSubmitting },
    } = formContext;

    // Block navigating elsewhere when data has been entered into the input
    const blocker = useBlocker(({ currentLocation, nextLocation }) => {
        if (nextLocation.pathname.includes('/delete')) return false;

        return (
            isDirty &&
            !isSubmitting &&
            !isSubmitted &&
            currentLocation.pathname !== nextLocation.pathname
        );
    });

    return (
        <EntityDiscardChangedDialog
            isOpen={blocker.state === 'blocked'}
            onResolve={() => {
                if (blocker.proceed) {
                    blocker.proceed();
                }
            }}
            onReject={() => {
                if (blocker.reset) {
                    blocker.reset();
                }
            }}
        />
    );
}
